// TEMPORARY: canned cube base game responses, played in sequence for testing.
// Generated from /responses/*.json. Response 5 has its win fields zeroed out.
// Delete together with the hijack in extendedSpinActionCube.ts.
/* eslint-disable */
export const mockSpinResponses: unknown[] = [
	{
		stake: 2,
		settings: {},
		allowedCommands: [
			"decreaseBet",
			"increaseBet",
			"maxBet",
			"saveUserSettings",
			"setBetAndActiveWinlines",
			"setFortuneWheelActive",
			"showPaytable",
			"spin",
		],
		state: {
			bet: 40,
			winOfRound: {
				credits: 0,
				freeGames: 0,
			},
			balance: 97986,
			slotGame: {
				fortuneWheel: {},
				activeWinLines: 20,
				reels: [
					["LV4", "LV4", "HV2", "HV2", "HV2", "LV1"],
					["HV2", "LV3", "LV3", "LV3", "LV2", "LV2"],
					["HV1", "HV1", "HV1", "LV2", "LV2", "HV2"],
					["LV2", "LV2", "LV2", "LV2", "HV2", "HV2"],
					["HV4", "HV4", "LV1", "LV1", "SCATTER", "LV4"],
				],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "INACTIVE",
					},
					revealComponent: {
						revealedSymbols: [],
					},
					nudgingComponent: {
						nudgingOffsets: [0, 0, 0, 0, 0],
					},
					nextWinMultiplier: 1,
				},
			},
			totalWin: 0,
		},
		transition: {
			bet: 40,
			winOfRound: {
				credits: 0,
				freeGames: 0,
			},
			balance: 97946,
			slotGame: {
				attentionSpinTypePerReel: [],
				symbolAnimations: [],
				attentionSpinReelIndexes: [],
				fortuneWheel: {},
				scatterTeaserPositions: [],
				winSymbols: [],
				activeWinLines: 20,
				basicWin: {
					credits: 0,
					winFactor: 0.0,
				},
				reels: [
					["HV1", "HV1", "LV1", "LV1", "LV1", "SCATTER", "LV4", "LV4", "LV4", "HV2", "HV2", "LV2"],
					["LV4", "LV1", "HV3", "FLOWER", "FLOWER", "FLOWER", "FLOWER", "HV1", "HV1", "LV4", "HV3", "HV3"],
					["LV3", "HV2", "HV2", "HV2", "LV1", "LV1", "LV4", "LV4", "LV4", "TOP", "LV2", "LV2"],
					["LV4", "LV4", "LV4", "LV4", "HV1", "HV1", "HV1", "LV1", "LV1", "LV1", "HV4", "HV4"],
					["FLOWER", "FLOWER", "FLOWER", "HV3", "LV4", "HV4", "HV4", "HV4", "HV4", "HV4", "LV2", "LV2"],
				],
				winLines: [],
				triggers: [],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "RUNNING",
					},
					revealComponent: {
						revealedSymbols: [
							{
								symbol: "HV3",
								position: [0, 4],
							},
							{
								symbol: "HV3",
								position: [1, 4],
							},
							{
								symbol: "HV3",
								position: [2, 1],
							},
							{
								symbol: "HV3",
								position: [3, 1],
							},
						],
					},
					nudgingComponent: {
						nudgingOffsets: [0, -1, 0, 0, -1],
					},
					nextWinMultiplier: 1,
				},
			},
			lineBets: {
				possibleValues: [1, 2, 3, 5, 10, 15, 20, 30],
			},
			totalWin: 0,
		},
		requestCommand: "spin",
	},
	{
		stake: 2,
		settings: {},
		allowedCommands: [
			"decreaseBet",
			"increaseBet",
			"maxBet",
			"saveUserSettings",
			"setBetAndActiveWinlines",
			"setFortuneWheelActive",
			"showPaytable",
			"spin",
		],
		state: {
			bet: 40,
			winOfRound: {
				credits: 0,
				freeGames: 0,
			},
			balance: 97946,
			slotGame: {
				fortuneWheel: {},
				activeWinLines: 20,
				reels: [
					["HV1", "HV1", "LV1", "LV1", "LV1", "SCATTER"],
					["LV4", "LV1", "HV3", "FLOWER", "FLOWER", "FLOWER"],
					["LV3", "HV2", "HV2", "HV2", "LV1", "LV1"],
					["LV4", "LV4", "LV4", "LV4", "HV1", "HV1"],
					["FLOWER", "FLOWER", "FLOWER", "HV3", "LV4", "HV4"],
				],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "RUNNING",
					},
					revealComponent: {
						revealedSymbols: [
							{
								symbol: "HV3",
								position: [0, 4],
							},
							{
								symbol: "HV3",
								position: [1, 4],
							},
							{
								symbol: "HV3",
								position: [2, 1],
							},
							{
								symbol: "HV3",
								position: [3, 1],
							},
						],
					},
					nudgingComponent: {
						nudgingOffsets: [0, -1, 0, 0, -1],
					},
					nextWinMultiplier: 1,
				},
			},
			totalWin: 0,
		},
		transition: {
			bet: 40,
			winOfRound: {
				credits: 300,
				freeGames: 0,
			},
			balance: 98206,
			slotGame: {
				attentionSpinTypePerReel: [],
				symbolAnimations: [],
				attentionSpinReelIndexes: [],
				fortuneWheel: {},
				scatterTeaserPositions: [],
				winSymbols: [],
				activeWinLines: 20,
				basicWin: {
					credits: 300,
					winFactor: 7.5,
				},
				reels: [
					["HV3", "HV4", "LV3", "SCATTER", "LV4", "LV4", "LV4", "HV2", "HV2", "HV2", "LV1", "LV1"],
					["LV2", "HV4", "LV1", "HV3", "FLOWER", "FLOWER", "FLOWER", "FLOWER", "HV1", "HV1", "LV4", "HV3"],
					["LV2", "HV4", "HV4", "HV4", "LV4", "LV4", "HV1", "HV1", "HV1", "LV4", "LV4", "LV4"],
					["LV4", "HV4", "HV2", "HV2", "HV2", "LV4", "LV4", "LV4", "LV4", "HV1", "HV1", "HV1"],
					["FLOWER", "FLOWER", "FLOWER", "FLOWER", "HV3", "LV4", "HV4", "HV4", "HV4", "HV4", "HV4", "LV2"],
				],
				winLines: [
					{
						freeGames: 0,
						positions: [
							[0, 0],
							[0, 1],
							[0, 2],
							[0, 3],
							[0, 4],
						],
						id: 2,
						win: 300,
					},
				],
				triggers: [],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "RUNNING",
					},
					revealComponent: {
						revealedSymbols: [
							{
								symbol: "HV4",
								position: [0, 4],
							},
							{
								symbol: "HV4",
								position: [1, 4],
							},
							{
								symbol: "HV4",
								position: [2, 4],
							},
							{
								symbol: "HV4",
								position: [3, 1],
							},
						],
					},
					nudgingComponent: {
						nudgingOffsets: [0, 0, 0, 0, -1],
					},
					nextWinMultiplier: 1,
				},
			},
			lineBets: {
				possibleValues: [1, 2, 3, 5, 10, 15, 20, 30],
			},
			totalWin: 300,
		},
		requestCommand: "spin",
	},
		{
		stake: 2,
		settings: {},
		allowedCommands: [
			"decreaseBet",
			"increaseBet",
			"maxBet",
			"saveUserSettings",
			"setBetAndActiveWinlines",
			"setFortuneWheelActive",
			"showPaytable",
			"spin",
		],
		state: {
			bet: 40,
			winOfRound: {
				credits: 0,
				freeGames: 0,
			},
			balance: 97906,
			slotGame: {
				fortuneWheel: {},
				activeWinLines: 20,
				reels: [
					["HV3", "LV3", "LV3", "SCATTER", "LV4", "LV4"],
					["LV2", "LV4", "LV1", "HV3", "FLOWER", "FLOWER"],
					["LV2", "HV4", "HV4", "HV4", "LV4", "LV4"],
					["LV4", "HV2", "HV2", "HV2", "HV2", "LV4"],
					["FLOWER", "FLOWER", "FLOWER", "FLOWER", "HV3", "LV4"],
				],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "RUNNING",
					},
					revealComponent: {
						revealedSymbols: [
							{
								symbol: "HV4",
								position: [0, 4],
							},
							{
								symbol: "HV4",
								position: [1, 4],
							},
							{
								symbol: "HV4",
								position: [2, 4],
							},
							{
								symbol: "HV4",
								position: [3, 1],
							},
						],
					},
					nudgingComponent: {
						nudgingOffsets: [0, 0, 0, 0, -1],
					},
					nextWinMultiplier: 1,
				},
			},
			totalWin: 0,
		},
		transition: {
			bet: 40,
			winOfRound: {
				credits: 320,
				freeGames: 0,
			},
			balance: 98186,
			slotGame: {
				attentionSpinTypePerReel: [],
				symbolAnimations: [],
				attentionSpinReelIndexes: [],
				fortuneWheel: {},
				scatterTeaserPositions: [],
				winSymbols: [],
				activeWinLines: 20,
				basicWin: {
					credits: 320,
					winFactor: 8.0,
				},
				reels: [
					["SCATTER", "LV4", "LV4", "LV4", "HV2", "HV2", "HV2", "LV1", "LV1", "TOP", "LV3", "LV3"],
					["LV3", "LV3", "LV2", "LV2", "LV2", "TOP", "LV3", "LV3", "LV3", "LV1", "LV1", "HV4"],
					["LV3", "LV3", "LV3", "HV2", "HV2", "HV2", "LV1", "LV1", "LV4", "LV4", "LV4", "TOP"],
					["HV3", "HV3", "LV3", "LV3", "LV3", "LV4", "LV4", "LV4", "HV2", "HV2", "HV2", "LV1"],
					["HV3", "FLOWER", "FLOWER", "FLOWER", "FLOWER", "HV3", "LV4", "HV4", "HV4", "HV4", "HV4", "HV4"],
				],
				winLines: [],
				triggers: [],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "RUNNING",
					},
					revealComponent: {
						revealedSymbols: [
							{
								symbol: "CALAVERA_X1",
								calaveraWin: 40,
								position: [0, 4],
							},
							{
								symbol: "CALAVERA_X5",
								calaveraWin: 200,
								position: [1, 4],
							},
							{
								symbol: "SCATTER",
								position: [2, 4],
							},
							{
								symbol: "CALAVERA_X2",
								calaveraWin: 80,
								position: [3, 4],
							},
						],
					},
					nudgingComponent: {
						nudgingOffsets: [0, 0, 0, 0, -1],
					},
					nextWinMultiplier: 1,
				},
			},
			lineBets: {
				possibleValues: [1, 2, 3, 5, 10, 15, 20, 30],
			},
			totalWin: 320,
		},
		requestCommand: "spin",
	},
	{
		stake: 2,
		settings: {},
		allowedCommands: [
			"decreaseBet",
			"increaseBet",
			"maxBet",
			"saveUserSettings",
			"setBetAndActiveWinlines",
			"setFortuneWheelActive",
			"showPaytable",
			"spin",
		],
		state: {
			bet: 40,
			winOfRound: {
				credits: 0,
				freeGames: 0,
			},
			balance: 97866,
			slotGame: {
				fortuneWheel: {},
				activeWinLines: 20,
				reels: [
					["SCATTER", "LV4", "LV4", "LV4", "HV2", "HV2"],
					["LV3", "LV3", "LV2", "LV2", "LV2", "TOP"],
					["LV3", "LV3", "LV3", "HV2", "HV2", "HV2"],
					["HV3", "HV3", "LV3", "LV3", "LV3", "SCATTER"],
					["HV3", "FLOWER", "FLOWER", "FLOWER", "FLOWER", "HV3"],
				],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "RUNNING",
					},
					revealComponent: {
						revealedSymbols: [
							{
								symbol: "HV4",
								position: [0, 4],
							},
							{
								symbol: "HV4",
								position: [1, 4],
							},
							{
								symbol: "HV4",
								position: [2, 4],
							},
							{
								symbol: "HV4",
								position: [3, 4],
							},
						],
					},
					nudgingComponent: {
						nudgingOffsets: [0, 0, 0, 0, -1],
					},
					nextWinMultiplier: 1,
				},
			},
			totalWin: 0,
		},
		transition: {
			bet: 40,
			winOfRound: {
				credits: 0,
				freeGames: 0,
			},
			balance: 97826,
			slotGame: {
				attentionSpinTypePerReel: [],
				symbolAnimations: [],
				attentionSpinReelIndexes: [],
				fortuneWheel: {},
				scatterTeaserPositions: [],
				winSymbols: [],
				activeWinLines: 20,
				basicWin: {
					credits: 0,
					winFactor: 0.0,
				},
				reels: [
					["HV3", "HV3", "HV3", "HV3", "LV2", "LV2", "LV2", "LV2", "HV2", "HV2", "HV2", "LV3"],
					["LV1", "LV1", "HV4", "HV4", "LV4", "LV4", "HV2", "HV2", "LV2", "LV2", "LV2", "SCATTER"],
					["LV3", "LV3", "LV3", "LV1", "LV1", "HV3", "HV3", "HV3", "LV2", "LV2", "LV2", "HV4"],
					["HV2", "LV1", "LV1", "LV1", "HV3", "HV3", "HV3", "HV3", "LV1", "LV1", "LV1", "TOP"],
					["HV1", "HV3", "FLOWER", "FLOWER", "FLOWER", "FLOWER", "HV3", "LV4", "HV4", "HV4", "HV4", "HV4"],
				],
				winLines: [],
				triggers: [],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "RUNNING",
					},
					revealComponent: {
						revealedSymbols: [
							{
								symbol: "HV2",
								position: [1, 4],
							},
							{
								symbol: "HV2",
								position: [2, 4],
							},
							{
								symbol: "HV2",
								position: [3, 4],
							},
						],
					},
					nudgingComponent: {
						nudgingOffsets: [0, 0, 0, 0, -1],
					},
					nextWinMultiplier: 1,
				},
			},
			lineBets: {
				possibleValues: [1, 2, 3, 5, 10, 15, 20, 30],
			},
			totalWin: 0,
		},
		requestCommand: "spin",
	},
	{
		stake: 2,
		settings: {},
		allowedCommands: [
			"decreaseBet",
			"increaseBet",
			"maxBet",
			"saveUserSettings",
			"setBetAndActiveWinlines",
			"setFortuneWheelActive",
			"showPaytable",
			"spin",
		],
		state: {
			bet: 40,
			winOfRound: {
				credits: 0,
				freeGames: 0,
			},
			balance: 97826,
			slotGame: {
				fortuneWheel: {},
				activeWinLines: 20,
				reels: [
					["HV3", "HV3", "HV3", "HV3", "LV2", "LV2"],
					["LV1", "LV1", "HV4", "HV4", "LV4", "LV4"],
					["LV3", "LV3", "LV3", "LV1", "LV1", "HV3"],
					["HV2", "LV1", "LV1", "LV1", "HV3", "HV3"],
					["HV1", "HV3", "FLOWER", "FLOWER", "FLOWER", "FLOWER"],
				],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "RUNNING",
					},
					revealComponent: {
						revealedSymbols: [
							{
								symbol: "HV2",
								position: [1, 4],
							},
							{
								symbol: "HV2",
								position: [2, 4],
							},
							{
								symbol: "HV2",
								position: [3, 4],
							},
						],
					},
					nudgingComponent: {
						nudgingOffsets: [0, 0, 0, 0, -1],
					},
					nextWinMultiplier: 1,
				},
			},
			totalWin: 0,
		},
		transition: {
			bet: 40,
			winOfRound: {
				credits: 0,
				freeGames: 0,
			},
			balance: 97786,
			slotGame: {
				attentionSpinTypePerReel: [],
				symbolAnimations: [],
				attentionSpinReelIndexes: [],
				fortuneWheel: {},
				scatterTeaserPositions: [],
				winSymbols: [],
				activeWinLines: 20,
				basicWin: {
					credits: 0,
					winFactor: 0.0,
				},
				reels: [
					["LV3", "LV3", "LV3", "LV3", "HV4", "HV4", "LV2", "LV2", "LV2", "HV1", "HV1", "HV1"],
					["HV3", "LV3", "LV3", "LV3", "LV3", "HV4", "HV4", "LV4", "LV4", "LV3", "LV3", "LV3"],
					["LV3", "LV3", "LV3", "HV4", "HV4", "HV4", "HV4", "LV2", "LV2", "LV2", "TOP", "LV3"],
					["LV1", "LV1", "TOP", "LV2", "LV2", "HV4", "HV4", "HV4", "LV4", "LV1", "LV1", "FLOWER"],
					["LV3", "HV1", "HV3", "FLOWER", "FLOWER", "FLOWER", "FLOWER", "HV3", "LV4", "HV4", "HV4", "HV4"],
				],
				winLines: [],
				triggers: [],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "RUNNING",
					},
					revealComponent: {
						revealedSymbols: [
							{
								symbol: "HV4",
								position: [2, 4],
							},
							{
								symbol: "HV4",
								position: [3, 4],
							},
						],
					},
					nudgingComponent: {
						nudgingOffsets: [0, 0, 0, 0, -1],
					},
					nextWinMultiplier: 1,
				},
			},
			lineBets: {
				possibleValues: [1, 2, 3, 5, 10, 15, 20, 30],
			},
			totalWin: 0,
		},
		requestCommand: "spin",
	},
	{
		stake: 2,
		settings: {},
		allowedCommands: [
			"decreaseBet",
			"increaseBet",
			"maxBet",
			"saveUserSettings",
			"setBetAndActiveWinlines",
			"setFortuneWheelActive",
			"showPaytable",
			"spin",
		],
		state: {
			bet: 40,
			winOfRound: {
				credits: 116,
				freeGames: 0,
			},
			balance: 97902,
			slotGame: {
				fortuneWheel: {},
				activeWinLines: 20,
				reels: [
					["LV3", "LV3", "LV3", "LV3", "HV4", "HV4"],
					["HV3", "LV3", "LV3", "LV3", "LV3", "HV4"],
					["LV3", "LV3", "LV3", "HV4", "HV4", "HV4"],
					["LV1", "LV1", "TOP", "LV2", "LV2", "HV4"],
					["LV3", "HV1", "HV3", "FLOWER", "FLOWER", "FLOWER"],
				],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "RUNNING",
					},
					revealComponent: {
						revealedSymbols: [
							{
								symbol: "HV4",
								position: [2, 4],
							},
							{
								symbol: "HV4",
								position: [3, 4],
							},
						],
					},
					nudgingComponent: {
						nudgingOffsets: [0, 0, 0, 0, -1],
					},
					nextWinMultiplier: 1,
				},
			},
			totalWin: 0,
		},
		transition: {
			bet: 40,
			winOfRound: {
				credits: 0,
				freeGames: 0,
			},
			balance: 97862,
			slotGame: {
				attentionSpinTypePerReel: [],
				symbolAnimations: [],
				attentionSpinReelIndexes: [],
				fortuneWheel: {},
				scatterTeaserPositions: [],
				winSymbols: [],
				activeWinLines: 20,
				basicWin: {
					credits: 0,
					winFactor: 0.0,
				},
				reels: [
					["HV3", "HV3", "HV3", "HV3", "LV4", "LV4", "TOP", "LV3", "LV3", "LV3", "LV3", "HV2"],
					["LV4", "LV4", "LV3", "LV3", "LV3", "LV3", "HV1", "HV1", "HV1", "LV1", "LV1", "LV1"],
					["LV4", "HV4", "HV4", "HV4", "HV4", "LV1", "LV1", "HV3", "HV3", "LV4", "LV4", "TOP"],
					["LV3", "SCATTER", "LV4", "LV4", "LV4", "HV3", "HV3", "HV3", "LV3", "LV3", "SCATTER", "LV2"],
					["HV1", "LV3", "HV1", "HV3", "FLOWER", "FLOWER", "FLOWER", "FLOWER", "HV3", "LV4", "HV4", "HV4"],
				],
				winLines: [],
				triggers: [],
				nudgeAndReveal: {
					currentWinMultiplier: 1,
					nudgingSequenceStates: {
						"40": "RUNNING",
					},
					revealComponent: {
						revealedSymbols: [
							{
								symbol: "HV2",
								position: [3, 4],
							},
						],
					},
					nudgingComponent: {
						nudgingOffsets: [0, 0, 0, 0, 0],
					},
					nextWinMultiplier: 1,
				},
			},
			lineBets: {
				possibleValues: [1, 2, 3, 5, 10, 15, 20, 30],
			},
			totalWin: 0,
		},
		requestCommand: "spin",
	},
];
